import { render } from "./SupportBanner.vue?vue&type=template&id=ff41d4c8&scoped=true"
import script from "./SupportBanner.vue?vue&type=script&lang=js"
export * from "./SupportBanner.vue?vue&type=script&lang=js"

import "./SupportBanner.vue?vue&type=style&index=0&id=ff41d4c8&lang=css"
import "./SupportBanner.vue?vue&type=style&index=1&id=ff41d4c8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff41d4c8"],['__file',"src/views/components/SupportBanner.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ff41d4c8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ff41d4c8', __exports__)) {
    api.reload('ff41d4c8', __exports__)
  }
  
  module.hot.accept("./SupportBanner.vue?vue&type=template&id=ff41d4c8&scoped=true", () => {
    api.rerender('ff41d4c8', render)
  })

}


export default __exports__